import http from '@/assets/js/interceptor';
// 获取模版组下拉框
export function getTplGroup () {
  return http.get('/tplGroup/getTplGroup', { domainType: 'bpmApi' });
}
// 保存基本信息
export function saveBaseInfo (formData) {
  return http.post('/tplConfig/insert/base', formData, { domainType: 'bpmApi' });
}
// 编辑保存基本信息
export function editBaseInfo (formData) {
  return http.put('/tplConfig/update/base', formData, { domainType: 'bpmApi' });
}
// 保存表单
export function saveFormDesign (data) {
  return http.post('/tplConfig/upsertForm', data, { domainType: 'bpmApi' });
};
// 保存流程图
export function saveProcessDesign (data) {
  return http.post('/tplConfig/upsertFlow', data, { domainType: 'bpmApi' });
};
// 保存高级设置
export function saveAdvancedSettings (data) {
  return http.post('/tplConfig/upsertConfigOp', data, { domainType: 'bpmApi' });
};
// 获取基本信息的数据
export function getBaseInfoData (tplConfigId) {
  return http.get(`/tplConfig/detail/base/${tplConfigId}`, { domainType: 'bpmApi' });
}
// 获取表单设计内容
export function getFormDesignData (tplConfigId) {
  return http.get(`/tplConfig/detail/form/${tplConfigId}`, { domainType: 'bpmApi' });
}
// 获取流程图数据
export function getProcessDesignData (tplConfigId) {
  return http.get(`/tplConfig/detail/flow/${tplConfigId}`, { domainType: 'bpmApi' });
}
// 获取高级设置数据
export function getAdvancedSettingsData (tplConfigId) {
  return http.get(`/tplConfig/detail/configOp/${tplConfigId}`, { domainType: 'bpmApi' });
}
// 获取最大的排序
export function getMaxSortNum () {
  return http.get('/tplConfig/getSort', { domainType: 'bpmApi' });
}
